import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, MapPin, Star } from 'lucide-react';
import dayjs from 'dayjs';

export default function EventCard({ event, variant = 'horizontal', testId }) {
  const navigate = useNavigate();

  const widthClass = variant === 'horizontal'
    ? 'w-[260px] min-w-[260px] mr-4'
    : variant === 'wide'
    ? 'w-full'
    : 'w-[48%]';

  return (
    <button
      data-testid={testId || `event-card-${event.id}`}
      onClick={() => navigate(`/event/${event.id}`)}
      className={`${widthClass} bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-200 text-left flex-shrink-0`}
    >
      <div className="relative">
        <img
          src={event.banner_url}
          alt={event.title}
          className="w-full h-40 object-cover bg-gray-100"
          loading="lazy"
        />
        {event.is_featured && (
          <span className="absolute top-3 left-3 bg-brand-magenta text-white text-[10px] font-extrabold tracking-wide px-2.5 py-1 rounded-full flex items-center gap-1">
            <Star className="w-3 h-3 fill-current" />
            Featured
          </span>
        )}
      </div>
      <div className="p-4 flex flex-col gap-1.5">
        <div className="flex items-center gap-1.5">
          <span className="text-[10px] font-extrabold text-brand-magenta tracking-widest uppercase">
            {event.category}
          </span>
          <span className="text-gray-400 text-xs">·</span>
          <span className="text-[11px] text-gray-500 font-semibold">{event.city}</span>
        </div>
        <h3 className="text-[15px] font-extrabold text-gray-900 leading-snug line-clamp-2">
          {event.title}
        </h3>
        <div className="flex items-center gap-1.5 mt-0.5">
          <Calendar className="w-3.5 h-3.5 text-gray-400" />
          <span className="text-xs text-gray-500">
            {dayjs(event.start_datetime).format('ddd, MMM D · h:mm A')}
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          <MapPin className="w-3.5 h-3.5 text-gray-400" />
          <span className="text-xs text-gray-500 truncate">{event.venue_name}</span>
        </div>
      </div>
    </button>
  );
}
